import React from "react";
import StoreDetail from "../Component/StoreDetail";
import Navbar from "../Component/Navbar";
import Footer from "../Component/Footer";

const StoreDetailPage = () => {
  return (
    <div>
      <Navbar />
      <StoreDetail />
      <Footer />
    </div>
  );
};

export default StoreDetailPage;